module.exports = __webpack_public_path__ + "static/media/asi.c1c8ed03.gif";